module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper slug-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c6a9b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SlugPage.vue
// module id = 255
// module chunks = 0